import { isEmpty } from 'lodash';
import { useMemo } from 'react';

import { HealthProviderTranslationItemDataFragment } from '../../../data/types/api/graphql';
import { CustomFormattedMessage } from '../../../elements/intl/custom-formatted-message';
import { HealthProviderTranslationListItem } from './health-provider-translation-list-item';

type HealthProviderTranslationListProps = {
  loading?: boolean;
  items: HealthProviderTranslationItemDataFragment[];
  onClick?: (value: HealthProviderTranslationItemDataFragment) => void;
};

export function HealthProviderTranslationsList({
  loading = false,
  onClick,
  ...props
}: HealthProviderTranslationListProps) {
  const items = useMemo(() => props.items, [props.items]);

  if (loading) {
    return (
      <p>
        <CustomFormattedMessage id="common.loading" />
      </p>
    );
  }

  if (isEmpty(items)) {
    return (
      <p>
        <CustomFormattedMessage id="common.no-data" />
      </p>
    );
  }

  return (
    <div className="content-list">
      {items.map(option => (
        <div key={option.key} className="content-list__item">
          <HealthProviderTranslationListItem
            translation={option}
            onClick={onClick}
          />
        </div>
      ))}
    </div>
  );
}
